import { Injectable } from '@angular/core';

import { VueAccountManagementService, VueSessionCookieService } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SelectedQuestionsResolve {
  public constructor(
    private vueAccountManagementService: VueAccountManagementService,
    private vueSessionCookieService: VueSessionCookieService
  ) { }

  public resolve(): Observable<number[]> {
    const userId = this.vueSessionCookieService.getAttribute('appUserId');
    return this.vueAccountManagementService.getSelectedSecurityQuestions(userId)
      .pipe(
        catchError(() => {
          return of(null);
        })
      );
  }
}
